module.exports = __webpack_public_path__ + "img/iphone.245a29d4.jpg";